export const WalletStaticData = {
  myAccountText: 'My Account',
  walletText: 'Wallet',
  detailsText: 'Details',
  transactionDetailsText: 'Transaction Details',
  totalBalanceText: 'Total Balance',
  vestedText: 'Vested',
  availableForWithdrawalText: 'Available for Withdrawal',
  lastWithdrawalText: 'Last Withdrawal',
  allText: 'All',
  receivedText: 'Received',
  withdrawalText: 'Withdrawal',
  otherText: 'Other',
};

export const WalletHindiData = {
  myAccountText: 'मेरा खाता',
  walletText: 'बटुआ',
  detailsText: 'विवरण',
  transactionDetailsText: 'लेन-देन विवरण',
  totalBalanceText: 'कुल शेष',
  vestedText: 'निवेशित',
  availableForWithdrawalText: 'निकासी के लिए उपलब्ध',
  lastWithdrawalText: 'अंतिम निकासी',
  allText: 'सभी',
  receivedText: 'प्राप्त',
  withdrawalText: 'निकासी',
  otherText: 'अन्य',
};

export const WalletArabicData = {
  myAccountText: 'حسابي',
  walletText: 'المحفظة',
  detailsText: 'التفاصيل',
  transactionDetailsText: 'تفاصيل المعاملة',
  totalBalanceText: 'الرصيد الإجمالي',
  vestedText: 'المستثمر',
  availableForWithdrawalText: 'متاح للسحب',
  lastWithdrawalText: 'آخر سحب',
  allText: 'الكل',
  receivedText: 'مستلم',
  withdrawalText: 'سحب',
  otherText: 'أخرى',
};
